import React, { useState, useEffect } from 'react';
import styles from '../Lists.module.css';
import { ListCommand } from '../../../types/ListCommands';

const delay = (ms: number) => new Promise(res => setTimeout(res, ms));

interface StackViewProps {
  command: ListCommand | null;
  onComplete: () => void;
}
const initialStackState = Array.from({ length: 5 }, () => Math.floor(Math.random() * 100))
const StackView: React.FC<StackViewProps> = ({ command, onComplete }) => {
const [stack, setStack] = useState<number[]>(initialStackState);
  const [highlightedIndex, setHighlightedIndex] = useState<number | null>(null);
  const [operation, setOperation] = useState<'push' | 'pop' | null>(null);

  useEffect(() => {
    if (command) {
      executeCommand(command);
    }
  }, [command]);

  const executeCommand = async (cmd: ListCommand) => {
    switch (cmd.action) {
      case 'addLast': 
        if (stack.length < 8) {
          setOperation('push');
          await delay(300);
          setStack(prev => [...prev, cmd.value]);
          setHighlightedIndex(stack.length);
          await delay(300);
        }
        break;

      case 'removeLast':
        if (stack.length > 0) {
          setOperation('pop');
          setHighlightedIndex(stack.length - 1);
          await delay(300);
          setStack(prev => prev.slice(0, -1));
          await delay(300);
        }
        break;

      case 'addFirst':
        if (stack.length < 8) {
            let currentStack = [...stack];
            const tempStorage: number[] = [];
            
            while (currentStack.length > 0) {
                setOperation('pop');
                setHighlightedIndex(currentStack.length - 1);
                await delay(150);
                tempStorage.push(currentStack.pop()!);
                setStack([...currentStack]);
                await delay(150);
            }

            setOperation('push');
            currentStack.push(cmd.value);
            setStack([...currentStack]);
            setHighlightedIndex(0);
            await delay(300);

            while (tempStorage.length > 0) {
                const item = tempStorage.pop()!;
                setOperation('push');
                await delay(150);
                currentStack.push(item);
                setStack([...currentStack]);
                setHighlightedIndex(currentStack.length - 1);
                await delay(150);
            }
        }
        break;

      case 'removeFirst': 
        if (stack.length > 0) {
            let currentStack = [...stack];
            const tempStorage: number[] = [];
            
            while (currentStack.length > 1) {
                setOperation('pop');
                setHighlightedIndex(currentStack.length - 1);
                await delay(150);
                tempStorage.push(currentStack.pop()!);
                setStack([...currentStack]);
                await delay(150);
            }
            
            setOperation('pop');
            setHighlightedIndex(0);
            await delay(500);
            currentStack.pop();
            setStack([...currentStack]);
            await delay(500);

            while (tempStorage.length > 0) {
                const item = tempStorage.pop()!;
                setOperation('push');
                await delay(150);
                currentStack.push(item);
                setStack([...currentStack]);
                setHighlightedIndex(currentStack.length - 1);
                await delay(150);
            }
        }
        break;
      case 'reset':
        const newRandomState = Array.from({ length: 5 }, () => Math.floor(Math.random() * 100));
        setStack(newRandomState);
        await delay(300);
        break;
    }

    setHighlightedIndex(null);
    setOperation(null);
    onComplete();
  };

  return (
    <div className={styles.comparisonContainer}>
      <h3 className={styles.comparisonTitle}>Stack (LIFO)</h3>
      <div className={styles.visualization}>
        <div className={`${styles.stackContainer}`}>
          {stack.map((value, index) => (
            <div
              key={index}
              className={`${styles.node} ${highlightedIndex === index ? styles.highlighted : ''} ${operation === 'pop' && highlightedIndex === index ? styles.popEffect : ''} ${operation === 'push' && highlightedIndex === index ? styles.pushEffect : ''}`}
            >
              {value}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StackView;